'use client';

// import { CustomImage as Image } from '..';
import { useGsapContext } from 'hooks/animation/useGsapContext';
import { useRef } from 'react';
import { useIsomorphicLayoutEffect } from 'hooks/dom/useIsomorphicLayoutEffect';
import { Container } from '..';
import { PLargeGradient } from '../blood-vision/styleConstants';
import gsap from 'gsap';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { useTranslations } from 'next-intl';
import styles from './TextOpacityOnScrollSection.module.css';

export const TextOpacityOnScrollSection = ({
  className,
}: {
  className?: string;
}) => {
    const t = useTranslations('ring');
    const { width } = useWindowSize();
    const gsapContext = useGsapContext();

    const container = useRef<HTMLDivElement>(null);
    const sentence = t('ring.infoModals.powerplugs');
    const words = sentence.split(/\s+/).filter(Boolean);

    const animationInit = () => {
      if (!container.current || !window) return;

      gsapContext.add(() => {
        const tl = gsap.timeline({
          defaults: {
            duration: 5,
            ease: 'power2.easeInOut',
          },
          scrollTrigger: {
            trigger: container.current,
            start: 'top top',
            end: 'bottom bottom',
            scrub: 0.1,
            immediateRender: false,
          },
        });

        tl.set(`.tc-1 > span.t`, {
          autoAlpha: 0.3,
        });

        tl.fromTo(
          '.tc-1 > span.t',
          {
            autoAlpha: 0.3,
          },
          {
            autoAlpha: 1,
            duration: 0.55,
            stagger: 0.1,
          },
          0.2,
        );

        tl.addPause(5.5);
      });
    };

    const intersectionObserver = useRef<IntersectionObserver | null>(null);

    useIsomorphicLayoutEffect(() => {
      intersectionObserver.current = new IntersectionObserver(
        () => {
          animationInit();
        },
        {
          root: null,
          rootMargin: '100px',
          threshold: 0,
        },
      );

      intersectionObserver.current.observe(container.current as Element);

      return () => {
        if (intersectionObserver.current) {
          intersectionObserver.current.disconnect();
        }
      };
    }, []);

    return (
      <section
        className={[styles.root, className].filter(Boolean).join(' ')}
        ref={container}
      >
        <div className={styles.stickyWrapper}>
          <Container
            style={{
              position: 'relative',
              height: '100%',
              display: 'grid',
              placeItems: 'center',
              // border : "2px solid red"
            }}
          >
            <PLargeGradient
              className="text-content tc-1"
              style={
                width > 992
                  ? {
                      fontWeight: '500',
                      // fontSize: '48px',
                      lineHeight: '140%',
                      letterSpacing: '-1.92px',
                    }
                  : {
                      fontWeight: '500',
                      // fontSize: '24px',
                      lineHeight: '140%',
                      letterSpacing: '0.96px',
                      padding: '0 25px',
                    }
              }
            >
              {words.map((word, i) => (
                <span key={i} className="t">
                  {word}
                  {i < words.length - 1 ? ' ' : ''}
                </span>
              ))}
            </PLargeGradient>
          </Container>
        </div>
      </section>
    );
};
